import { SimpleEventDispatcher } from 'ste-simple-events';
import { SignalDispatcher } from 'ste-signals';

export const contactEvents = {
  userLinksChanged: new SimpleEventDispatcher<number>(),
  userConnected: new SimpleEventDispatcher<number>(),
  newContactCreated: new SignalDispatcher(),
};
